import React from "react";
import HeroLayout from "../components/HeroLayout";
import { Link } from "react-router-dom";
const images = require.context("../assets/images", false);

function Hotel_List() {
  return (
    <>
    <HeroLayout>
    <div
  className="banner-bg bg-top"
  style={{
    backgroundImage:
      `linear-gradient(#370b2e66, #370b2e66), url(${images("./Rambagh-palace-jaipur.jpeg")})`
  }}
>
  <div className="container">
    <div className="inner-banner-content full-width center color-white mt-5">
      <h1>Luxury Hotels List</h1>
    </div>
  </div>
</div>

    </HeroLayout>
   <div className="hotel-list paddingY-70">
  <div className="container">
    <div className="heading center">
      <h2>Delhi Hotels</h2>
    </div>
    <div className="row">
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Leela-Palace-hotel-Delhi.jpg")} />
          <h3 className="mb-2">THE LEELA PALACE HOTEL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Luxury
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 254
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.theleela.com/en_us/hotels-in-delhi/the-leela-palace-hotel-new-delhi/">Click here…</Link>
          </p>
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Oberoi-New-Delhi-1.jpg")} />
          <h3 className="mb-2">THE OBEROI HOTEL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Luxury
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 220
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.oberoihotels.com/hotels-in-delhi/">Click here…</Link>
          </p>
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Imperial-Hotel-Delhi.jpg")} />
          <h3 className="mb-2">THE IMPERIAL HOTEL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Luxury Heritage
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 235
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://theimperialindia.com/">Click here…</Link>
          </p>
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./The-Taj-Palace-Delhi.jpg")} />
          <h3 className="mb-2">THE TaJ PALACE HOTEL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 403
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.tajhotels.com/en-in/taj/taj-palace-new-delhi/">Click here…</Link>
          </p>
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Taj-Mahal-Hotel-Delhi1.jpeg")} />
          <h3 className="mb-2">THE TAJ MAHAL HOTEL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 292
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.tajhotels.com/en-in/taj/taj-mahal-new-delhi/">Click here…</Link>
          </p>
        </div>
      </div>
            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Shagri-La-Delhi-1.jpg")} />
          <h3 className="mb-2">SHANGRI-LA HOTEL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 320
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.shangri-la.com/en/newdelhi/erosshangrila/">Click here…</Link>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div className="container mt-4">
    <div className="heading center">
      <h2>AGRA HOTELS</h2>
    </div>
    <div className="row">
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Oberoi-Amarvilas-Hotel-Agra.jpg")} />
          <h3 className="mb-2">The OBEROI AMARVILAS</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Luxury
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 102
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.oberoihotels.com/hotels-in-agra-amarvilas-resort/">Click here…</Link>
          </p>
        </div>
      </div>
      
            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./ITC-Mughal-Agra.jpg")} />
          <h3 className="mb-2">ITC MUGHAL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 233
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.itchotels.in/hotels/agra/itcmughal.html">Click here…</Link>
          </p>
        </div>
      </div>
            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Trident-Agra.jpg")} />
          <h3 className="mb-2">TRIDENT AGRA</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 137
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.tridenthotels.com/hotels-in-agra">Click here…</Link>
          </p>
        </div>
      </div>
            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Taj-Hotel-Agra-1.jpeg")} />
          <h3 className="mb-2">TAJ HOTEL</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 236
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.tajhotels.com/en-in/taj/taj-hotel-and-convention-centre-agra/">Click here…</Link>
          </p>
        </div>
      </div>
            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Marriot-Hotel-Agra.jpg")} />
          <h3 className="mb-2">Courtyard by marriot</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 189
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.marriott.com/hotels/travel/agrcy-courtyard-agra/">Click here…</Link>
          </p>
        </div>
      </div>

            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Sarovar-Hotel-Agra-1.jpg")} />
          <h3 className="mb-2">Grand Mercure Agra</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 112
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://all.accor.com/hotel/C0W7/index.en.shtml">Click here…</Link>
          </p>
        </div>
      </div>

    </div>
  </div>


 <div className="container mt-4">
    <div className="heading center">
      <h2>JAIPUR HOTELS</h2>
    </div>
    <div className="row">
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Oberoi-Rajvilas-6.jpg")} />
          <h3 className="mb-2">The OBEROI RAJVILAS</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Luxury
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 71
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.oberoihotels.com/hotels-in-jaipur-rajvilas-resort/">Click here…</Link>
          </p>
        </div>
      </div>
         <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Taj-Rambagh-Jaipur-1.jpg")} />
          <h3 className="mb-2">TAJ RAMBAGH PALACE
</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Luxury Heritage
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 79
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.tajhotels.com/en-in/taj/rambagh-palace-jaipur/">Click here…</Link>
          </p>
        </div>
      </div>
      
      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Taj-Jai-Mahal11.jpeg")} />
          <h3 className="mb-2">TAJ JAI MAHAL PALACE
</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Heritage
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 100
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.sarovarhotels.com/crystal-sarovar-premiere-agra/">Click here…</Link>
          </p>
        </div>
      </div>


      <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./leela-palace-jaipur.jpeg")} />
          <h3 className="mb-2">LEELA PALACE JAIPUR </h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star Luxury
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 198
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.theleela.com/the-leela-palace-jaipur">Click here…</Link>
          </p>
        </div>
      </div>

         
            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Samode-Haveli.jpg")} />
          <h3 className="mb-2">SAMODE HAVELI
</h3>
          <p className="mb-2">
            <b>Category:</b> 4 Star Heritage
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 39
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.samode.com/samode-haveli/">Click here…</Link>
          </p>
        </div>
      </div>
            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Fairmont-Jaipur.jpg")} />
          <h3 className="mb-2">FAIRMONT JAIPUR
</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 245
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.fairmont.com/jaipur/">Click here…</Link>
          </p>
        </div>
      </div>
            

      



            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Hilton-Jaipur-211.jpg")} />
          <h3 className="mb-2">HILTON JAIPUR
</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 179
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.hilton.com/en/hotels/jaighhi-hilton-jaipur/">Click here…</Link>
          </p>
        </div>
      </div>
            

            <div className="col-md-6 col-lg-4">
        <div className="hotel-list-card">
          <img src={images("./Trident-Jaipur-1.jpg")} />
          <h3 className="mb-2">TRIDENT JAIPUR
</h3>
          <p className="mb-2">
            <b>Category:</b> 5 Star
          </p>
          <p className="mb-2">
            <b>No. of Rooms:</b> 132
          </p>
          <p className="mb-5">
            <b>Website:</b> <Link to="https://www.tridenthotels.com/hotels-in-jaipur">Click here…</Link>
          </p>
        </div>
      </div>
    </div>
  </div>




</div>

    </>
  );
}

export default Hotel_List;